<template>
  <div class="view_case_info">
    <el-card>
      <div class="view_case_info_one">
        <div class="view_case_info_one_left">
          <el-image :src="caseInfo.companyLogoKey" />
        </div>
        <div class="view_case_info_one_right">
          <div class="view_case_info_one_right_title">
            {{ caseInfo.recruitmentPosition
            }}<span style="margin-left: 6px">[{{ caseInfo.itemNo }}]</span>
          </div>
          <div class="view_case_info_one_right_li">公司名称：{{ caseInfo.corporateName }}</div>
          <div class="view_case_info_one_right_li">工作地点：{{ caseInfo.dutyStation }}</div>
          <div class="view_case_info_one_right_li">所属行业：{{ caseInfo.industry }}</div>
          <div class="view_case_info_one_right_li">职位类型：{{ caseInfo.positionType }}</div>
          <div class="view_case_info_one_right_li">薪资范围：{{ caseInfo.salaryRange }}</div>
        </div>
      </div>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="view_case_info_two">
        <div class="view_case_info_two_left">
          <div class="view_case_info_two_left_li">客户经理：{{ caseInfo.createName }}</div>
          <div
            class="view_case_info_two_left_li"
            :key="index"
            v-for="(item, index) in caseInfo.projectTimeResults"
          >
            项目顾问{{ index + 1 }}：{{ item.consultantName }}
          </div>
        </div>
        <div class="view_case_info_two_right">
          <p>启动日期：2021-1-25 15:25:26</p>
          <p>完成日期：2021-1-25 15:25:26</p>
        </div>
        <div class="view_case_info_two_bottom">
          <!-- businessManagement/projectCenter/projectRecord -->
          <span @click="projectRecord">查看项目记录</span>
        </div>
      </div>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="view_case_info_three">
        <div class="view_case_info_three_title">
          项目状况：{{ caseInfo.projectPhase }}
          <!-- <span @click="editBaoClick">查看寻访方案</span> -->
        </div>
        <div class="view_case_info_three_title">
          沟通人数：{{ caseInfo.number }}
          <span v-if="caseInfo.number" @click="goutongClick">查看沟通列表</span>
        </div>
        <div class="view_case_info_three_title">推荐人数：{{ caseInfo.count }}</div>
        <div class="view_case_info_three_ul">
          <div class="view_case_info_three_ul_left">推荐人才：</div>
          <div class="view_case_info_three_ul_right">
            <div class="view_case_info_three_ul_li"></div>
          </div>
        </div>
        <div class="view_case_info_three_induction_title">入职信息</div>
        <div
          class="view_case_info_three_induction"
          v-for="(item, index) in caseInfo.candidateResults"
          :key="index"
        >
          <div class="view_case_info_three_recruiter">入职人：{{ item.name }}</div>
          <div class="view_case_info_three_salary">
            <p>offer薪资：</p>
            <div class="view_case_info_three_salary_flex">
              <div class="view_case_info_three_salary_left">年薪：{{ item.annualSalary }}</div>
              <div class="view_case_info_three_salary_center">
                <span>薪资构成</span>
                <div></div>
              </div>
              <div class="view_case_info_three_salary_right">
                <div class="view_case_info_three_salary_right_li">
                  固定月薪：{{ item.monthlySalary }}
                </div>
                <div class="view_case_info_three_salary_right_li">
                  年度奖金：{{ item.annualBonus }}
                </div>
                <div class="view_case_info_three_salary_right_li">
                  绩效奖金：{{ item.achievementBonus }}
                </div>
                <div class="view_case_info_three_salary_right_li">提成：{{ item.commission }}</div>
                <div class="view_case_info_three_salary_right_li">其他：{{ item.other }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="view_case_info_three_summary">
          <div class="view_case_info_three_summary_left">项目总结：</div>
          <div class="view_case_info_three_summary_right">{{ caseInfo.projectDetails }}</div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { projectId } from '@/api/caseCenter.js'
export default {
  name: 'viewCaseInfo',
  data() {
    return {
      caseInfo: {
        companyLogoKey: '', //公司logo
        recruitmentPosition: ''
      }
    }
  },
  created() {
    this.search()
    this.$store.commit('changeQueryInfo', this.searchInfo)
  },
  computed: {
    //用户id
    id() {
      return this.$route.query.id
    },
    //人才编号
    personnelId() {
      return this.$route.query.personnelId
    },
    searchInfo() {
      return JSON.parse(this.$route.query.searchInfo)
    }
  },
  methods: {
    //编辑报告
    editBaoClick() {
      console.log(this.personnelId)
      this.$router.push({
        name: 'EditReport',
        query: { personCode: this.personnelId, projectId: this.id }
      })
    },
    //沟通列表
    goutongClick() {
      this.$router.push({
        name: 'Candidate',
        query: { id: this.id, positionType: this.caseInfo.positionType, tabName: 'third' }
      })
    },
    //项目记录
    projectRecord() {
      this.$router.push({
        name: 'projectRecord',
        query: { id: this.id }
      })
    },
    async search() {
      const { data: res } = await projectId({ id: this.id, personnelId: this.personnelId })
      if (res.resultCode === 200) {
        this.caseInfo = res.data
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view_case_info {
  width: 100%;

  .view_case_info_one {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;

    .view_case_info_one_left {
      width: 100px;
      margin-right: 16px;
      overflow: hidden;

      /deep/ .el-image {
        width: 100px;
        height: 100px;
        overflow: hidden;
      }
    }

    .view_case_info_one_right {
      flex: 1;
      overflow: hidden;

      .view_case_info_one_right_title {
        width: 100%;
        overflow: hidden;
        color: #17757a;
        font-size: 18px;
        font-weight: 500;
      }

      .view_case_info_one_right_li {
        width: 30%;
        float: left;
        overflow: hidden;
        margin-right: 3%;
        margin-top: 16px;
        color: #333333;
        font-size: 14px;
      }
    }
  }

  .view_case_info_two {
    width: 50%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
  .view_case_info_two_left {
    flex: 1;
    overflow: hidden;
    margin-right: 24px;

    .view_case_info_two_left_li {
      width: 100%;
      overflow: hidden;
      color: #000000;
      font-size: 14px;
      margin-bottom: 12px;
    }
  }

  .view_case_info_two_right {
    p {
      color: #000000;
      font-size: 14px;
      margin-bottom: 6px;
    }
  }

  .view_case_info_two_bottom {
    margin-left: 24px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    span {
      color: #4d70fa;
      font-size: 12px;
      padding: 0;
      font-weight: 400;
      cursor: pointer;
      display: inline-block;
    }
  }

  .view_case_info_three {
    width: 100%;
    overflow: hidden;

    .view_case_info_three_title {
      color: #000000;
      font-size: 14px;
      margin-bottom: 12px;

      span {
        color: #4d70fa;
        font-size: 12px;
        margin-left: 12px;
        cursor: pointer;
      }
    }
    .view_case_info_three_ul {
      font-size: 14px;
    }

    .view_case_info_three_induction_title {
      font-size: 14px;
      color: #000000;
      margin-top: 40px;
    }

    .view_case_info_three_induction {
      box-sizing: border-box;
      padding: 10px 20px;

      .view_case_info_three_recruiter {
        margin-bottom: 12px;
        font-size: 14px;
        color: #000;
      }

      .view_case_info_three_salary {
        padding-bottom: 20px;
        border-bottom: 1px solid #eee;

        .view_case_info_three_salary_flex {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          overflow: hidden;
          align-items: center;
          box-sizing: border-box;
          padding: 10px 20px;

          .view_case_info_three_salary_left {
            width: 15%;
            overflow: hidden;
            margin-right: 80px;
            color: #000000;
            font-size: 14px;
          }

          .view_case_info_three_salary_center {
            width: 15%;
            margin-right: 80px;
            font-size: 14px;
            align-items: center;
            color: #000;
            display: flex;
            flex-direction: column;

            div {
              width: 100%;
              position: relative;
              height: 2px;
              margin-top: 8px;
              background-color: #eee;
            }
            div:before {
              position: absolute;
              top: 50%;
              right: 0;
              margin-top: -4px;
              content: ' ';
              display: inline-block;
              height: 6px;
              width: 6px;
              border-width: 2px 2px 0 0;
              border-color: #c8c8cd;
              border-style: solid;
              -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
              transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
            }

            div:after {
              content: ' ';
              position: absolute;
              right: 0;
              top: 0;
              width: 1px;
              bottom: 0;
              border-right: 1px solid #d9d9d9;
              color: #d9d9d9;
              -webkit-transform-origin: 100% 0;
              transform-origin: 100% 0;
              -webkit-transform: scaleX(0.5);
              transform: scaleX(0.5);
            }
          }

          .view_case_info_three_salary_right {
            flex: 1;
            overflow: hidden;

            .view_case_info_three_salary_right_li {
              width: 50%;
              overflow: hidden;
              float: left;
              box-sizing: border-box;
              padding-right: 24px;
              margin-bottom: 20px;
              color: #000;
              font-size: 14px;
            }
          }
        }
      }
    }

    .view_case_info_three_summary {
      width: 80%;
      margin-top: 60px;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      font-size: 14px;
      color: #000;
      margin-bottom: 60px;

      .view_case_info_three_summary_left {
        margin-right: 12px;
        overflow: hidden;
      }

      .view_case_info_three_summary_right {
        flex: 1;
        overflow: hidden;
        line-height: 1.5em;
      }
    }
  }
}
</style>
